import { render, staticRenderFns } from "./BTextField.vue?vue&type=template&id=43f5a426"
import script from "./BTextField.vue?vue&type=script&lang=ts"
export * from "./BTextField.vue?vue&type=script&lang=ts"
import style0 from "./BTextField.vue?vue&type=style&index=0&id=43f5a426&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports